/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react';
import { SendBirdInstance } from 'sendbird';

export interface SendBirdContextValue {
  sendbird: SendBirdInstance;
  appId: string;
}

export const SendBirdContext = createContext<SendBirdContextValue>({} as any);

export const useSendBirdContext = () => useContext(SendBirdContext);
